import React from 'react';
import './SkeletonCard.css';

export default function SkeletonCard() {
  return (
    <div className="skeleton-card">
      <div className="skeleton-image" />
      <div className="skeleton-body">
        <div className="skeleton-line line-title" />
        <div className="skeleton-line line-subtitle" />
        <div className="skeleton-btn" />
      </div>
    </div>
  );
}
